import { QueryClient } from '@tanstack/react-query'
import { searchEstablishmentsList } from '@/modules/accredited-establishments/api'
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_OFFSET
} from '@/modules/accredited-establishments/constants/accredited-establishments'
import { makeSearchEstablishmentsListQueryKey } from '@/modules/accredited-establishments/functions/make-search-establishments-query-key'
import {
  fetchFilters,
  fetchValidSubSpecialtyId,
  getQueryParams,
  validateParams
} from './prefetchAccreditedEstablishmentsList.helpers'
import { Query } from '@/global/types/serverSideProps'

const prefetchAccreditedEstablishmentsList = async (
  queryClient: QueryClient,
  searchParams: Query
) => {
  const {
    planParam,
    categoriesParam,
    specialtyParam,
    subSpecialtyParam,
    genderParam,
    appointmentTypeParam,
    providerNameParam,
    addressSearchParam,
    addressParam
  } = getQueryParams(searchParams)

  const { plans, specialties, addresses } = await fetchFilters({
    queryClient,
    filtersParams: {
      addressSearchParam,
      addressParam
    }
  })

  const { categoryIds, specialtyId, planId, placeId } = validateParams({
    params: { planParam, specialtyParam, addressParam, categoriesParam },
    filtersOptions: { plans, specialties, addresses }
  })

  const subSpecialtyId = await fetchValidSubSpecialtyId({
    queryClient,
    specialtyId,
    subSpecialtyParam
  })

  /*
   * Genero e atendimento sao chips da categoria de especialista: fora dela nao
   * ha o que filtrar, e o cliente tambem os descarta — a chave de cache tem de
   * bater com a do cliente, senao a hidratacao refaz a busca.
   */
  const isSpecialistSearch = !!categoryIds?.includes('SPECIALIST')

  const filters = {
    categoryIds,
    siteAccreditedNetworkId: planId,
    specialtyId,
    subSpecialtyId,
    ...(isSpecialistSearch && genderParam ? { gender: genderParam } : {}),
    ...(isSpecialistSearch && appointmentTypeParam
      ? { appointmentType: appointmentTypeParam }
      : {}),
    providerName: providerNameParam,
    placeId
  }

  await queryClient.prefetchInfiniteQuery({
    queryKey: makeSearchEstablishmentsListQueryKey({
      ...filters
    }),
    queryFn: () =>
      searchEstablishmentsList({
        ...filters,
        offset: DEFAULT_PAGINATION_OFFSET,
        limit: DEFAULT_PAGINATION_LIMIT
      }),
    initialPageParam: [DEFAULT_PAGINATION_OFFSET, DEFAULT_PAGINATION_LIMIT]
  })
}

export { prefetchAccreditedEstablishmentsList }
